import "@/App.css";
import "@/styles/nexi-chat.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import { PremiumProvider } from "@/context/PremiumContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { ThemeProvider } from "@/context/ThemeContext";
import UpgradeModal from "@/components/UpgradeModal";

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <PremiumProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
              </Routes>
            </BrowserRouter>
            <UpgradeModal />
            <Toaster position="bottom-center" />
          </div>
        </PremiumProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;